import { type Component, createApp } from 'vue'
import '@unocss/reset/tailwind.css'
import '@github/relative-time-element'
import '@ropescore/components/style.css'
import 'uno.css'
import App from './App.vue'
import router from './router'
import { ApolloClients } from '@vue/apollo-composable'
import { apolloClient, apolloClientAlternate } from './apollo'
import { createHead } from '@vueuse/head'
import { initializeApp } from 'firebase/app'
import { initFaro, setFaroView } from './faro'

initializeApp({
  apiKey: 'AIzaSyCbOo3XqKZfQWkfudXQ-_5OKvNaWnSeRsA',
  authDomain: 'ropescore-app.firebaseapp.com',
  projectId: 'ropescore-app',
  messagingSenderId: '224455118938',
  appId: '1:224455118938:web:f922c0fb34bc3bb2398863'
})

const faro = initFaro()

const app = createApp(App as Component)
const head = createHead()

if (faro != null) {
  app.config.errorHandler = (err, instance, info) => {
    const route = router.currentRoute.value

    faro.api.pushError(err instanceof Error ? err : new Error(String(err)), {
      context: {
        vueInfo: info,
        vueComponentName: instance?.$options.name ?? instance?.$options.__name ?? 'unknown',
        routePath: route.path,
        routeFullPath: route.fullPath,
      },
    })

    console.error(err)
  }

  router.afterEach(setFaroView)
}

app
  .provide(ApolloClients, {
    default: apolloClient,
    alternate: apolloClientAlternate
  })
  .use(router)
  .use(head)
  .mount('#app')
